import React, { forwardRef } from 'react';
import classnames from 'classnames';

import './PanelBlock.scss';

const PanelBlock = forwardRef((props, ref) => {
  const { children, className } = props;
  return (
    <div className={classnames('panel-block', className)} ref={ref}>
      {children}
    </div>
  );
});

PanelBlock.displayName = 'PanelBlock';

export default PanelBlock;
